import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import { FC } from 'react';
import { Trans } from 'react-i18next';
import { ScheduleAgreementState } from '../../types/api';
import styles from './ScheduleAgreementInfo.module.scss';

interface ScheduleAgreementInfoProps {
  scheduleAgreementState: ScheduleAgreementState;
}

/** string for schedule agreement state, null for no message */
const MESSAGE_MAP: Partial<Record<ScheduleAgreementState, string[] | null>> = {
  [ScheduleAgreementState.CONFIRMED]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-payment',
  ],
  [ScheduleAgreementState.PAID]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-sign-addendum',
  ],
  [ScheduleAgreementState.OVERDUE]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-payment',
  ],
  [ScheduleAgreementState.ADDENDUM_SENT]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-sign-addendum',
  ],
  [ScheduleAgreementState.ADDENDUM_EXPIRED]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-sign-addendum',
  ],
  [ScheduleAgreementState.NOTARY_RECORD]: [
    'schedule-agreement.state-common',
    'schedule-agreement.state-waiting-sign-notary',
  ],
  [ScheduleAgreementState.NEW]: ['schedule-agreement.waiting-confirmation'],
  // [ScheduleAgreementState.EMAIL_EXPIRED]: null,
  // [ScheduleAgreementState.DONE]: null,
  // [ScheduleAgreementState.CANCELED]: null,
};

const ScheduleAgreementInfo: FC<ScheduleAgreementInfoProps> = ({
  scheduleAgreementState,
}) => {
  const stateMessages = MESSAGE_MAP[scheduleAgreementState];

  if (!stateMessages) {
    return null;
  }

  return (
    <div className={styles['schedule-agreement-info-wrapper']}>
      <div className={styles['schedule-agreement-info']}>
        <div className={styles['icon']}>
          <InfoOutlinedIcon />
        </div>
        <div className={styles['message']}>
          {stateMessages
            ? stateMessages.map((message) => (
                <>
                  <Trans
                    key={message}
                    i18nKey={message}
                    components={{ strong: <strong /> }}
                  />{' '}
                </>
              ))
            : null}
        </div>
      </div>
    </div>
  );
};

export default ScheduleAgreementInfo;
